class Seafarer {
    id = null;
    approved = false;
    photo = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    status_id = null;
    planned_date = null;
    seafarer_book = '';
    with_azara_from = null;
    perfomance = null;
    attitude = null;
    communication = null;
    overall = null;
    notes = '';
    gdpr = false;
    gdpr_photo = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    name = '';
    surname = '';
    middle_name = '';
    date_of_birth = null;
    nationality_id = null;
    oib = '';
    country_of_residency_id = null;
    in_cimis = false;
    place_of_birth = '';
    gender_id = null;
    marital_status_id = null;
    phone = '';
    email = '';
    height = '';
    weight = '';
    shoe_size_eur = '';
    overall_size_id = 1;
    street_name_and_number = '';
    city = '';
    post_code = '';
    country_id = null;
    airport_id = null;
    emergency_contact_name = '';
    emergency_contact_relationship_id = null;
    emergency_contact_street_name_and_number = '';
    emergency_contact_city = '';
    emergency_contact_post_code = '';
    emergency_contact_country_id = null;
    contact_number = '';
    contact_email = '';
    bank_name = '';
    bank_address = '';
    bank_country_id = null;
    swift_code = '';
    bic = '';
    bank_acccount_holder_name = '';
    iban = '';
    account_currency_id = null;
    bank_town = '';
    bank_post_code = '';
    inactive_reason_id = null;
    available_date = null;
    rank_id = null;
    gdpr_edit_lock = false;
    bank_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Seafarer;
